import Typography from "mobily-ui-library/lib/components/primitive/Typography/Typography";
import { useTranslation } from "react-i18next";

export interface Props {
    rtl: boolean;
    OrderDetailsProduct:any;
}

function FiberOrderCard({ rtl, OrderDetailsProduct }: Props) {
    const { t } = useTranslation();

    const priceWithoutVat = parseFloat(OrderDetailsProduct.productInformation.packageName.price);
    const installationFee = parseFloat(OrderDetailsProduct.productInformation.packageName.nrc);
    const vatPrice = (installationFee + priceWithoutVat) * 0.15;
    const totalAmountWithVat = priceWithoutVat + installationFee + vatPrice;

    return (
        <div className={`orders-card`}>
            <Typography className='orders-card-title sansFont' rtl={rtl}>{OrderDetailsProduct.productInformation.packageName.value}</Typography>
            <div className='orders-lists'>
                <div className={`row`}>
                    <Typography className='col-sm-6 sansFont list-text' rtl={rtl}>{t("Monthly_Subscription_without_VAT")}</Typography>
                    <Typography className='col-sm-6 sansFont list-text' rtl={rtl}>{`${priceWithoutVat} ${t("SAR_Month")}`}</Typography>
                </div>
                <div className={`row`}>
                    <Typography className='col-sm-6 sansFont list-text' rtl={rtl}>{t("Installation_Fee_without_VAT")}</Typography>
                    <Typography className='col-sm-6 sansFont list-text' rtl={rtl}>{`${installationFee} ${t('SAR')}`}</Typography>
                </div>
                <div className={`row`}>
                    <Typography className='col-sm-6 sansFont list-text' rtl={rtl}>{t("VAT_amount")}</Typography>
                    <Typography className='col-sm-6 sansFont list-text' rtl={rtl}>{`${vatPrice} ${t('SAR')}`}</Typography>
                </div>

                <div className={`row fw-bold`}>
                    <Typography className='col-sm-6 sansFont list-text' rtl={rtl}>{t("Total_Amount_of_first_Bill")}</Typography>
                    <Typography className='col-sm-6 sansFont list-text' rtl={rtl}>{`${totalAmountWithVat} ${t('SAR')}`}</Typography>
                </div>
            </div>
        </div>
    )
}

export default FiberOrderCard